export const initialProjectDirectory = "view"